import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { FaSave, FaPaperPlane } from 'react-icons/fa';
import { smtpAPI } from '../services/api';
import { toast } from 'react-toastify';

const SMTPSettings = () => {
  const [settings, setSettings] = useState({
    host: '', port: 587, username: '', password: '', encryption: 'tls', from_email: '', from_name: '', is_active: true
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testEmail, setTestEmail] = useState('');
  const [testing, setTesting] = useState(false);

  useEffect(() => { fetchSettings(); }, []);

  const fetchSettings = async () => {
    try {
      const response = await smtpAPI.getSettings();
      if (response.data.data) setSettings(response.data.data);
    } catch (error) { toast.error('Failed to load settings'); }
    finally { setLoading(false); }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await smtpAPI.updateSettings(settings);
      toast.success('Settings saved');
    } catch (error) { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  const handleTest = async () => {
    if (!testEmail) { toast.error('Enter test email'); return; }
    setTesting(true);
    try {
      await smtpAPI.testConnection({ to: testEmail });
      toast.success('Test email sent');
    } catch (error) { toast.error('Test failed'); }
    finally { setTesting(false); }
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <div>
      <h3 className="mb-4">SMTP Settings</h3>

      <Row>
        <Col md={8}>
          <Card>
            <Card.Body>
              <Form onSubmit={handleSave}>
                <Row>
                  <Col md={8}><Form.Group className="mb-3"><Form.Label>SMTP Host</Form.Label><Form.Control required value={settings.host} onChange={(e) => setSettings({...settings, host: e.target.value})} placeholder="smtp.gmail.com" /></Form.Group></Col>
                  <Col md={4}><Form.Group className="mb-3"><Form.Label>Port</Form.Label><Form.Control type="number" required value={settings.port} onChange={(e) => setSettings({...settings, port: e.target.value})} /></Form.Group></Col>
                </Row>

                <Row>
                  <Col md={6}><Form.Group className="mb-3"><Form.Label>Username</Form.Label><Form.Control required value={settings.username} onChange={(e) => setSettings({...settings, username: e.target.value})} /></Form.Group></Col>
                  <Col md={6}><Form.Group className="mb-3"><Form.Label>Password</Form.Label><Form.Control type="password" required value={settings.password} onChange={(e) => setSettings({...settings, password: e.target.value})} /></Form.Group></Col>
                </Row>

                <Row>
                  <Col md={4}><Form.Group className="mb-3"><Form.Label>Encryption</Form.Label><Form.Select value={settings.encryption} onChange={(e) => setSettings({...settings, encryption: e.target.value})}><option value="none">None</option><option value="ssl">SSL</option><option value="tls">TLS</option></Form.Select></Form.Group></Col>
                  <Col md={4}><Form.Group className="mb-3"><Form.Label>From Email</Form.Label><Form.Control type="email" required value={settings.from_email} onChange={(e) => setSettings({...settings, from_email: e.target.value})} /></Form.Group></Col>
                  <Col md={4}><Form.Group className="mb-3"><Form.Label>From Name</Form.Label><Form.Control required value={settings.from_name} onChange={(e) => setSettings({...settings, from_name: e.target.value})} /></Form.Group></Col>
                </Row>

                <Form.Check type="checkbox" label="Active" checked={settings.is_active} onChange={(e) => setSettings({...settings, is_active: e.target.checked})} className="mb-3" />

                <Button variant="primary" type="submit" disabled={saving}><FaSave /> {saving ? 'Saving...' : 'Save Settings'}</Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card>
            <Card.Header>Test Configuration</Card.Header>
            <Card.Body>
              <Alert variant="info">Send a test email to verify your settings.</Alert>
              <Form.Group className="mb-3"><Form.Label>Test Email Address</Form.Label><Form.Control type="email" value={testEmail} onChange={(e) => setTestEmail(e.target.value)} placeholder="your@email.com" /></Form.Group>
              <Button variant="success" onClick={handleTest} disabled={testing} className="w-100"><FaPaperPlane /> {testing ? 'Sending...' : 'Send Test Email'}</Button>
            </Card.Body>
          </Card>

          <Card className="mt-3">
            <Card.Header>Common Settings</Card.Header>
            <Card.Body>
              <strong>Gmail:</strong><br/>Host: smtp.gmail.com<br/>Port: 587<br/>Encryption: TLS<hr/>
              <strong>Outlook:</strong><br/>Host: smtp.office365.com<br/>Port: 587<br/>Encryption: TLS<hr/>
              <strong>For Gmail:</strong> Use App Password, not your regular password.
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SMTPSettings;
